import { useEffect } from 'react';
import moment from 'moment';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { DownloadIcon } from 'Asset/icon';
import ButtonSolid from 'UiKit/button/buttonSolid';
import FilterYearMonthPicker from 'UiKit/filter-year-month-picker';
import { TextSemiBold } from 'UiKit/typography';
import useGetExportOperatorPresence from 'Domain/report-attendance-operator/useGetExportOperatorPresence';
import { reportAttendanceOperatorText } from 'View/report-attendance-operator/const';
import { ReportAttendanceText } from 'View/report-attendance/const';
import { useReportAttendanceOperatorState } from 'View/report-attendance-operator/state';

import styles from './styles.module.css';

const Filter = () => {
  const { filterState, updateFilterState } = useReportAttendanceOperatorState();
  const { t } = useTranslation('report-attendance')
  const params = useParams();
  const { id } = params;
  const isOperator = !Boolean(id);

  const [searchParams] = useSearchParams();
  const monthYear = searchParams.get('monthYear') && moment(searchParams.get('monthYear'), 'MM-YYYY');

  const { mutate } = useGetExportOperatorPresence();

  const handleExportReport = () => {
    mutate({ ...filterState, id });
  };

  useEffect(() => {
    if (monthYear && !isOperator) {
      updateFilterState({ monthYear: monthYear.toDate() });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isOperator) {
    return (
      <Box className={styles['filter__container--list']}>
        <FilterYearMonthPicker
          placeholder={t('filter.selectMonth')}
          value={filterState?.monthYear}
          onChange={(value) => updateFilterState({ monthYear: value })}
        />
      </Box>
    );
  }

  return (
    <Box className={styles['filter__container--detail']}>
      <FilterYearMonthPicker
        placeholder={ReportAttendanceText.monthYearPickerPlaceholder}
        value={filterState?.monthYear}
        onChange={(value) => updateFilterState({ page: 1, monthYear: value })}
      />
      <ButtonSolid className={styles['filter__button-export']} onClick={handleExportReport}>
        <DownloadIcon size="18px" />
        <TextSemiBold className={styles['filter__button-export--text']}>{reportAttendanceOperatorText.buttonExportText}</TextSemiBold>
      </ButtonSolid>
    </Box>
  );
};

export default Filter;
